export default __webpack_public_path__ + "static/char-s-08-en-09ebee0835e7116d060be33b1da6da34.webp";